import { cloneDeep } from 'lodash-es'
import React, { useState } from 'react'
import { Form, Checkbox, Message, Panel, Row } from 'rsuite'
import { isValidators } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'

export default function CheckboxRowHaveSubForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  isInput,
}) {
  const [schema, setSchema] = useState(_schema)
  const [optionSelected, setOptionSelected] = useState(
    _schema?.optionSelected?.length > 0 ? _schema.optionSelected : null
  )

  const onChangeCheckbox = (value, checked) => {
    // console.log('value : ', value, 'checked : ', checked)

    if (checked) {
      clearErrors('selectedList')
    }

    let selected = cloneDeep(optionSelected || [])
    const index = selected.indexOf(value)
    if (checked) {
      if (index === -1) {
        selected.push(value)
      }
    } else {
      if (index > -1) {
        selected.splice(index, 1)
      }
    }
    // console.log('selected : ', selected)
    setOptionSelected(selected)
    if (selected.length > 0) {
      // console.log('setValue.')
      setValue('selectedList', selected)
    } else {
      // console.log('setNull.')
      setValue('selectedList', '')
    }
  }

  const renderCheckBox = (data, keyStr) => {
    if (data?.isTitle) {
      let panelkey = `title_${keyStr}`
      let divkey = `div_title_${keyStr}`
      // console.log('title : ', panelkey, ' divkey : ', divkey)
      return (
        <Panel
          key={panelkey}
          header={data.label}
          collapsible
          defaultExpanded
          style={{ marginBottom: -20 }}
        >
          <div key={divkey} style={{ marginTop: -20 }}>
            {data?.childs?.map((item, index) => {
              return renderCheckBox(item, `${panelkey}_${index}`)
            })}
          </div>
        </Panel>
      )
    } else if (data?.isSubTitle) {
      let panelkey = `subtitle_${keyStr}`
      let divkey = `div_subTitle_${keyStr}`
      // console.log('subtitle_ : ', panelkey, ' div_subTitle_ : ', divkey)
      return (
        <Panel
          key={panelkey}
          header={data.label}
          collapsible
          defaultExpanded
          style={{ marginTop: -20 }}
        >
          <div key={divkey} style={{ marginTop: -20 }}>
            {data?.childs?.map((item, index) => {
              return renderCheckBox(item, `${panelkey}_${index}`)
            })}
          </div>
        </Panel>
      )
    } else if (data?.isItem) {
      return (
        <Row>
          {/* {isInput && (
            <Col xs={3} sm={3} md={3} lg={3}>
              <Input
                key={`percent_${keyStr}`}
                name={`percentage_${data.value}`}
                disabled={!optionSelected?.includes(data.value)}
                placeholder="สัดส่วน %"
                defaultValue={data.percentage || 0.0}
                onChange={(value) => {
                  var values = value.split('.')
                  setValue(`percentage_${data.value}`, value)
                }}
              />
            </Col>
          )}
          <Col xs={21} sm={21} md={21} lg={21}> */}
          {data.isGroupTitle ? (
            <div style={{ marginLeft: 10, marginTop: 10, fontWeight: 550 }}> {data.label}</div>
          ) : (
            <Checkbox
              key={`data_${keyStr}`}
              value={data.value}
              checked={optionSelected?.includes(data.value)}
              onChange={(value, checked, e) => {
                if (checked) {
                  setValue(`percentage_${data.value}`, value)
                }
                onChangeCheckbox(value, checked)
              }}
            >
              {data.label}
            </Checkbox>
          )}

          {/* </Col> */}
        </Row>
      )
    }
  }

  return (
    <>
      <Form>
        <div>
          {schema.description && <CustomIconMessageInfo content={schema.description} />}

          <Controller
            key={'selectedList'}
            name={'selectedList'}
            control={control}
            defaultValue={optionSelected}
            // value={optionSelected}
            rules={isValidators(schema.validators)}
          />

          {schema.options.map((item, index) => (
            <div key={index}>{renderCheckBox(item, index)}</div>
          ))}

          {errors?.selectedList && (
            <Message
              style={{ marginTop: 10 }}
              showIcon
              type="error"
              description={errors.selectedList.message}
            />
          )}
        </div>
      </Form>
    </>
  )
}
